import { TableCard } from '../../../../components'
import { FormularioHeading } from '../formularios-create/component/FormularioHeading'
import { TiposAtendimentoVinculosListHeader } from './components/header/TiposAtendimentoVinculosListHeader'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { TiposAtendimentoVinculosTable } from './table/TiposAtendimentoVinculosTable'

const TiposAtendimentoVinculosList = () => (
  <>
    <FormularioHeading />
    <TableCard>
      <TiposAtendimentoVinculosListHeader />
      <TiposAtendimentoVinculosTable />
    </TableCard>
  </>
)

export const TiposAtendimentoVinculosListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListFiltersProvider>
        <TiposAtendimentoVinculosList />
      </ListFiltersProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
